import "./App.css";
import Sidebar from "./components/Sidebar/Sidebar";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Dashboard } from "./components/Dashboard/Dashboard";
import Login from "./components/Login/Login";
import AvailableBoardRoomList from "./components/Boardrooms/AvailableBoardRoomList";
import ReservationSchedule from "./components/Boardrooms/ReservationSchedule";
import 'bootstrap/dist/css/bootstrap.min.css';
import ProfileForm from "../src/components/EmployeeProfile/ProfileForm";
import AutoLogin from "./components/Login/AutoLogin"; // Import AutoLogin
import ReservationReport from "./components/Reports/ReservationReport"
import EquipmentReservation from "./components/Equipments/EquipmentReservation";
import EquipmentReservationReport from "./components/Reports/EquipmentReservationReport";

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(
        localStorage.getItem("userLoggedIn") === "true"
    );

    // Keep localStorage in sync when authentication state changes
    useEffect(() => {
        localStorage.setItem("userLoggedIn", isAuthenticated);
    }, [isAuthenticated]);

    return (
        <Router>
            <AppContent isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
        </Router>
    );
}

function AppContent({ isAuthenticated, setIsAuthenticated }) {
    const location = useLocation();
    const isLoginPage = location.pathname === "/";

    return (
        <>
            <AutoLogin setIsAuthenticated={setIsAuthenticated} />

            {!isLoginPage && isAuthenticated && <Sidebar setIsAuthenticated={setIsAuthenticated} />}
            <Routes>
                <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login setIsAuthenticated={setIsAuthenticated} />} />
                <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />} />
                <Route path="/assembly-hall" element={isAuthenticated ? <AvailableBoardRoomList /> : <Navigate to="/" />} />
                <Route path="/schedules" element={isAuthenticated ? <ReservationSchedule /> : <Navigate to="/" />} />
                <Route path="/equipments" element={isAuthenticated ? <EquipmentReservation /> : <Navigate to="/" />} />
                <Route path="/boardroom-reservation-report" element={isAuthenticated ? <ReservationReport /> : <Navigate to="/" />} />
                <Route path="/equipment-reservation-report" element={isAuthenticated ? <EquipmentReservationReport /> : <Navigate to="/" />} />
                <Route path="/my-account" element={isAuthenticated ? <ProfileForm /> : <Navigate to="/" />} />
            </Routes>
        </>
    );
}

export default App;